// extracted by mini-css-extract-plugin
module.exports = {"imgs":"Introduce_style_imgs__1UfXD"};